var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:[
    'btn',
    {
      primary: _vm.variant === 'primary',
      success: _vm.variant === 'success',
      secondary: _vm.variant === 'secondary',
      outline: _vm.variant === 'secondary-outline',
      delete: _vm.variant === 'delete',
      info: _vm.variant === 'info',
      danger: _vm.variant === 'danger',
      'danger-outline': _vm.variant === 'dangerOutline',
      secondary2: _vm.variant === 'secondary2',
      warning: _vm.variant === 'warning',
      'dark-blue': _vm.variant === 'darkBlue',
    },
    { 'sidebar-btn': _vm.small },
  ],style:(_vm.cus_style),attrs:{"id":_vm.id,"type":_vm.type,"disabled":_vm.disabled || _vm.loading},on:{"click":function($event){$event.stopPropagation();return _vm.click.apply(null, arguments)},"mouseenter":_vm.mouseenter,"mouseleave":_vm.mouseleave}},[_c('div',{staticClass:"d-flex justify-content-center align-items-center"},[(_vm.loading)?_c('b-spinner',{staticStyle:{"margin-inline-end":"0.5rem"},attrs:{"small":""}}):_vm._e(),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }